// highchartsLocalization.ts

// relative
import daDK from './highchartsDA.json';
import enUS from './highchartsEN.json';

import Highcharts from 'highcharts';

const highchartsLanguages = {
  dk: daDK,
  en: enUS,
} as const;

export const setHighchartsLanguage = (language: string = 'dk') => {
  const normalizedLanguage = language.split(
    '-',
  )[0] as keyof typeof highchartsLanguages;

  const lang =
    highchartsLanguages[normalizedLanguage] ?? highchartsLanguages.en;
  console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);
  Highcharts.setOptions({
    lang,
    time: {
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    tooltip: {
      valueDecimals: 2, // Forces 2 decimal places globally on all tooltips
      dateTimeLabelFormats: {
        millisecond: '%[YebHMS]',
      },
    },
  });
};
